import { render, staticRenderFns } from "./ComponentPreviewer.vue?vue&type=template&id=3e838bab&"
import script from "./ComponentPreviewer.vue?vue&type=script&lang=ts&"
export * from "./ComponentPreviewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard});
